import { FormStepType } from "./types";
import { applicant_details } from "./steps/applicant-details";
import { contact_information } from "./steps/contact-information";
import { passport_details_new } from "./steps/passport-details-new";
import { getParentsAndSpouseStep } from "./steps/parents-and-spouse";

export const form_ds_11: FormStepType[] = [
  applicant_details,
  contact_information({ additionalPhoneNumbers: 1 }),
  passport_details_new,
  getParentsAndSpouseStep({ id: 4 }),
];
